import { AxiosResponse } from 'axios'
import {
  ICryptoAmount,
  ICryptoAmountParams,
  IFiatAmountParams,
  IFiatProvider,
  IPostDonation,
  IStreamerConfig,
} from './types'
import { apiClient } from '@/entities/httpClient'

const urls = {
  config: (nickname: string) => `/streamer/${nickname}/config`,
  calculateCryptoAmount: (nickname: string) => `/streamer/${nickname}/calculate-crypto-amount`,
  calculateFiatAmount: (nickname: string) => `/streamer/${nickname}/calculate-fiat-amount`,
  donate: (nickname: string) => `/streamer/${nickname}/donate`,
}

export const streamerApi = {
  async getStreamerConfig(nickname: string): Promise<AxiosResponse<IStreamerConfig>> {
    return apiClient.request({
      url: urls.config(nickname),
      method: 'GET',
    })
  },
  async calculateCryptoAmount(nickname: string, params: ICryptoAmountParams): Promise<AxiosResponse<ICryptoAmount>> {
    return apiClient.request({
      url: urls.calculateCryptoAmount(nickname),
      data: params,
      method: 'POST',
    })
  },
  async calculateFiatAmount(nickname: string, params: IFiatAmountParams): Promise<AxiosResponse<IFiatProvider[]>> {
    return apiClient.request({
      url: urls.calculateFiatAmount(nickname),
      data: params,
      method: 'POST',
    })
  },
  async postDonate(nickname: string, params: FormData): Promise<AxiosResponse<IPostDonation>> {
    return apiClient.request({
      url: urls.donate(nickname),
      method: 'POST',
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
